export var getNewPageNumber = function (currentPageNumber, totalPages, cardsOnCurrentPage) {
    var isLastPage = currentPageNumber > 1 && currentPageNumber === totalPages;
    var isLastCardOnPage = cardsOnCurrentPage === 1;
    return isLastCardOnPage && isLastPage
        ? currentPageNumber - 1
        : currentPageNumber;
};
